const paths = {
  home: '/',
  login: '/login',
  new: '/new',

  plants: '/plants',
  scenarios: '/scenarios',
  storageSystems: '/storage-systems',
  users: '/users',

  results: '/results',
  resultDetail: '/results/:resultId',
  getResultDetailPath: (resultId: string) => `/results/${resultId}`,
  resultComparison: '/result-comparison/:resultIdA-:resultIdB',
  getResultComparisonPath: (resultIdA: string, resultIdB: string) =>
    `/result-comparison/${resultIdA}-${resultIdB}`,
}

export default paths
